export default __webpack_public_path__ + "static/media/background.d1c8278a.webp";